<template>
  <div class="index-nav">
    <!-- <black > -->
    <a
      index="index"
      @click="toIndex"
      v-if="
        isKeyUnit == '0' ||
        isKeyUnit == '1' ||
        deptStatus == '3'
      "
    >
      <i><img src="~@/assets/img/icon-home.png" alt="" /></i>
      <span>首页</span>
    </a>

    <a index="indexOther" @click="toIndexOther" v-if="isKeyUnit == '2'">
      <i><img src="~@/assets/img/icon-home.png" alt="" /></i>
      <span>首页</span>
    </a>

    <a
      index="homeConcise"
      @click="toHomeConcise"
      v-if="isKeyUnit == '6'"
    >
      <i><img src="~@/assets/img/icon-home.png" alt="" /></i>
      <span>首页</span>
    </a>
    <a
      v-for="(item, index) in homeBarList"
      :key="index"
      @click="handlePathClick(item.path)"
      :class="[
        item.num != 0 ? 'el-calss' : '',
        item.path == routerPath ? 'indexNavActive' : '',
        item.id === '7' ? 'w' : '',
      ]"
    >
      <el-badge :hidden="item.num <= 0" :max="badgeMax" :value="item.num" class="item">
        <i><img class="topBarIconImg" :src="item.img" alt="" /></i>
        <span>{{ item.name }}</span>
      </el-badge>
    </a>
    <!-- </black> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {channelStyleTp} from "@/js/constants";

export default {
  data() {
    return {
      routerPath: "",
      badgeMax: 1000,
    };
  },
  computed: {
    ...mapGetters("homeBar", ["homeBarList", "hzbjNum"]),
    isKeyUnit() {
      return this.$store.state.isKeyUnit;
    },
    deptStatus() {
      return this.$store.state.deptStatus;
    },
    isChannelStyleTp () {
      return this.$store.state.styleTp === channelStyleTp
    },
  },
  mounted() {
    this.updateMsgNumber();
  },
  methods: {
    ...mapActions("homeBar", ["updateMsgNumber"]),
    handlePathClick(path) {
      if (this.isChannelStyleTp) {
        if (path === '/fireWatch') {
          this.$router.push('/fireWatchChannel');
          return
        }
      }
      this.$router.push(path);
      this.routerPath = this.$route.path;
    },
    toIndex() {
      let deptStatus = this.deptStatus;
      let url = "";
      if (deptStatus === "0") {
        url = "/Street"; //智慧消防管理驾驶舱 (1.0街道首页)
      } else if (deptStatus === "1") {
        url = "/Street";
      } else if (deptStatus === "2") {
        url = "/home";
      } else if (deptStatus === "3") {
        url = "/home";
      }
      this.$router.push(url);
    },
    toIndexOther() {
      this.updateMsgNumber()
      this.$router.push("/homeWz")
    },
    toHomeConcise() {
      this.updateMsgNumber()
      this.$router.push("/homeConcise")
    },
  },
  updated() {
    this.routerPath = this.$route.path;
  },
};
</script>

<style lang="less" scoped>
.index-nav {
  float: left;
  .indexNavPadding {
    padding: 0px 130px 0px 0px;
  }

  a {
    // padding: 5px 5px;
    float: left;
    text-align: center;
    cursor: pointer;
    width: 60px;
    height: 62px;
    border: 0.1px solid transparent;
    border-radius: 10px;
    margin: 0 2px;

    &.w {
      width: 72px;
    }

    i {
      height: 24px;
      display: block;
      padding-bottom: 4px;
      margin-top: 7px;

      img {
        //width: 24px;
        height: 24px;
      }
    }

    span {
      font-size: 12px;
      // font-weight: bold;
      color: #fff;
    }
  }

  a:hover {
    span {
      color: #fff;
    }
    border: 0.1px solid #fff;
    background: linear-gradient(#ebfb8b, #ff9900);
    transition: 0.3s;
  }
  .topBarIconImg {
    width: 25px;
    height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue